// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-493a28ff] .vs-input--icon {\n  font-size: 23px;\n}\n", ""]);
// Exports
module.exports = exports;
